import { Link, useParams } from "wouter";
import { tipRegistry } from "../tip_registry.js";

function WelcomeTip() {
  const { orgSlug } = useParams<{ orgSlug: string }>();
  return (
    <div className="space-y-2 text-sm">
      <p>Welcome to scantling. Get started by connecting an integration.</p>
      <Link href={`/o/${orgSlug}/n`} className="text-primary hover:underline">
        Browse integrations →
      </Link>
    </div>
  );
}

tipRegistry.register({
  type: "welcome",
  order: 1,
  component: WelcomeTip,
});
